import { findKey } from 'lodash';

import { JobType } from 'interfaces/job';
import { humanize } from 'utils/helpers';

const jobTypeLabelOverrides: Partial<Record<JobType, string>> = {
  [JobType.MultiplexPeakDetection]: 'Spot Detection',
  [JobType.MultiplexTissueSegmentationMask]: 'Tissue Segmentation Mask',
  [JobType.BrightfieldTissueSegmentationMask]: 'Tissue Segmentation Mask',
  [JobType.MultiplexCellSegmentation]: 'Cell Segmentation',
  [JobType.CellSegmentation]: 'Cell Segmentation',
  [JobType.QaAnalysis]: 'QA Analysis',
  [JobType.QcAnalysis]: 'QC Analysis',
  [JobType.MifMarkerUnsupervisedAnalysis]: 'mIF Marker Unsupervised Analysis',
  [JobType.DetectTmaCores]: 'Detect TMA Wells',
  [JobType.CropTma]: 'Crop TMAs',
};

export const getJobTypeDisplayLabel = (jobType?: JobType) => {
  if (!jobType) {
    return '';
  }

  const jobTypeKey = findKey(JobType, (value) => value === jobType);
  return jobTypeLabelOverrides[jobType] || humanize(jobTypeKey || jobType);
};
